module.exports = __webpack_public_path__ + "img/card_front-v3.607a57c.png";